<template>
  <div class="volume-slider">
    <md-icon class="icon">volume_up</md-icon>
    <vue-slider
      class="slider"
      :min="0"
      :max="10"
      :interval="1"
      :height="10"
      :dot-size="10"
      :adsorb="true"
      :value="value * 10"
      @change="value => update(value / 10)"
    />
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component';

export default {
  name: 'volume-slider',
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      state: {
      },
    };
  },
  methods: {
    update(volume) {
      this.$emit('input', volume);
    },
  },
};
</script>
<style scoped>
.volume-slider {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.icon {
  width: 16px;
  height: 16px;
  font-size: 16px !important;
  color: white !important;
}
.slider {
  flex: 1;
  margin-left: 5px;
}
</style>
